export const DISTRIBUTOR_PRODUCTS_SET = 'DISTRIBUTOR_PRODUCTS_SET'
export const DISTRIBUTOR_PRODUCTS_STATS_SET = 'DISTRIBUTOR_PRODUCTS_STATS_SET'
export const DISTRIBUTOR_PRODUCTS_UPDATE = 'DISTRIBUTOR_PRODUCTS_UPDATE'
export const DISTRIBUTOR_PRODUCTS_FETCHING = 'DISTRIBUTOR_PRODUCTS_FETCHING'
export const DISTRIBUTOR_PRODUCTS_UPDATING = 'DISTRIBUTOR_PRODUCTS_UPDATING'
